export const UserPoolId = process.env.REACT_APP_USER_POOL_ID || ''
export const ClientId = process.env.REACT_APP_CLIENT_ID || ''
export const API_URL = process.env.REACT_APP_API_URL_USER || ''
export const API_URL_ORG = process.env.REACT_APP_API_URL_ORG || ''
export const API_URL_SETTINGS = process.env.REACT_APP_API_URL_SETTINGS || ''
export const STAGE = process.env.STAGE || ''
